// src/pages/HomePage.tsx
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Work from "@/components/Work";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen overflow-hidden">
      <Helmet>
        <title>Priya Pareek | Visual Artist & Designer</title>
        <meta
          name="description"
          content="Portfolio of Priya Pareek, a multidisciplinary visual artist and designer specializing in visual arts, design, and creative direction."
        />
      </Helmet>
      <Navbar />
      <Hero />
      <About />
      <Work />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;